<template>
  <!-- 加多一层占位main-nav，防止滚动时页面跳动 -->
  <nav class="global-header" :class="from==='basic'?'basic':''">
    <section class="global-header" :class="{'shadow': from!=='basic'}">
      <div class="top-bar" :class="{'fixed': scroll&&active!=='job'}">
        <div>
          <p>云沃客手机端<span><img src="../assets/images/common/header-app.png"></span></p>
          <p class="service"><a :href="prePath+'/contactus'">客服</a></p>
          <div>
            <template v-if="from!=='basic'">
              <ul>
                <li v-if="profile && !profile.id">
                  <a :href="prePath+'/workbench/jobs?ftype=c'">我是需求方</a></li>
                <li v-if="profile && !profile.id">
                  <a :href="prePath+'/workbench/jobs?ftype=f'">我是服务方</a></li>
                <li class="myjobs"><a :href="prePath+'/workbench/jobs'">我的项目</a></li>
                <li class="collect"><a :href="prePath+'/settings/favorite'">我的收藏</a></li>
                <li class="notify" :class="count>0?'active':''">
                  <a :href="prePath+'/notify'">通知<span v-if="count>0">(<em>{{count}}</em>)</span></a></li>
              </ul>
              <i></i>
              <ul>
                <template v-if="profile && profile.id">
                  <li><a :href="prePath+'/settings'">我的资料</a></li>
                  <li><a :href="prePath+'/accounts'">我的钱包</a></li>
                  <li><a :href="prePath+'/settings/security'">帐号设置</a></li>
                </template>
              </ul>
              <div v-if="profile && profile.id">
                <a class="user-avater">
                  <a :href="prePath+'/settings'" :title="profile.name">
                    <img :src="profile.avatar">
                    <span :title="profile.name">{{profile.name}}</span>
                  </a>
                  <div>
                    <ul>
                      <li><a :href="prePath+'/settings/favorite'">我的收藏</a></li>
                      <li><a :href="prePath+'/accounts'">我的钱包</a></li>
                      <li><a :href="prePath+'/settings/security'">帐号设置</a></li>
                      <li><a @click="showModal=true">退出登录</a></li>
                    </ul>
                  </div>
                </a>
              </div>
            </template>
            <template v-else>
              <div v-if="profile && profile.id">
                <a class="exit" @click="showModal=true" title="退出登录"></a>
              </div>
            </template>
            <ul v-if="profile && !profile.id">
              <li><a @click="login('signin')">登录</a></li>
              <li><a @click="login('signup')">注册</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="header-box" v-if="from!=='basic'">
        <a class="logo" v-if="!from" :href="prePath || '/'"></a>
        <a class="logo" v-else></a>
        <!-- 非资料完善 -->
        <template>
          <ul class="nav-box">
            <li><a :class="{active:active=='home'}" :href="prePath || '/'">首页</a></li>
            <li><a :class="{active:active=='job'||loc.indexOf('job')>=0}" :href="prePath+'/jobs'">在线商机</a></li>
            <li class="new"><a target="_blank" nofollow :href="entUrl">企业版</a></li>
            <li class="new"><a target="_blank" nofollow :href="residentUrl">
              <img class="menu-resident" src="../assets/images/common/icon-menu-resident.png" alt="黄豆纳才" />
              <img class="icon-menu-award" src="../assets/images/common/icon-menu-award.gif" alt="黄豆纳才" />
            </a></li>
            <li><a target="_blank" nofollow href="https://appmall.clouderwork.com/">标品商城</a></li>
            <li v-show="genius"><a :class="{active:active=='cowboy'||loc.indexOf('cowboy')>=0}" :href="prePath+'/cowboy'">牛人</a></li>
            <li><a :class="{active:active=='projects'||loc.indexOf('projects')>=0}" :href="prePath+'/projects'">优秀产品</a></li>
            <li><a :href="prePath+'/nodemap'">节点地图</a></li>
            <!-- <li><a :class="{active:active=='case'||loc.indexOf('case')>=0}" :href="prePath+'/case'">成功案例</a></li> -->
            <li><a :class="{active:active=='incubator'||loc.indexOf('incubator')>=0}" :href="prePath+'/incubator'">合作园区</a></li>
            <li><a :class="{active:active=='step'||(loc.indexOf('appraise')>=0&&loc.indexOf('/exam')<0)}" :href="appraiseUrl" nofollow>估价器</a></li>
            <!-- <li class="line"><a target="_blank" href="https://community.clouderwork.com">在么社区</a></li> -->
            <!-- <li><a target="_blank" href="//woke.clouderwork.com/" nofollow>沃客学院</a></li> -->
            <li><a target="_blank" :href="prePath+'/clouderwork/news.html'" nofollow>资讯</a></li>
          </ul>
        </template>
      </div>
    </section>
    <modal :show="showModal" @close="showModal=false" @cancel="showModal=false" @ok="loginOut">
      <p class="header-body" slot="header">退出登录</p>
      <p>确定退出登录云沃客平台吗？</p>
    </modal>
    <a v-if="profile && profile.id" class="yunliao-container menu-ykx" target="_blank" :href="wkxUrl+'&uuid='+profile.id"><p>即时沟通</p><span id="yunliao-report"></span></a>
  </nav>
</template>
<script>
import ywk from '@common/utils/ywk'
import modal from '@common/components/modal'
import {wkxUnread} from '@ywk/common'
import {utils} from '@ywk/utils'

export default {
  data () {
    return {
      scroll: true,
      count: 0,
      marquee: false,
      loc: window.location.href,
      // 登录地址
      signinUrl: '/signin',
      showModal: false,
      genius: ''
    }
  },
  props: {
    from: {
      type: String,
      default: ''
    },
    active: String
  },
  computed: {
    profile () {
      if (ywk.getCharLen(this.$root.$data.profile.name) > 8) {
        this.marquee = true
      }
      if (this.$root.$data.profile.id) {
        this.getNotifyCount()
        setInterval(this.getNotifyCount, 40000)
      }
      return this.$root.$data.profile
    },
    // 网站前缀
    prePath () {
      return WWW_DOMAIN
    },
    entUrl () {
      return ENT_DOMAIN
    },
    wkxUrl () {
      return YUNXUN_DOMAIN + '?from=1'
    },
    residentUrl () {
      return RESIDENT_DOMAIN
    },
    appraiseUrl () {
      return APPRAISE_DOMAIN
    }
  },
  created () {
    this.getGenius()
    // 处理登录地址
    if (location.pathname && location.pathname !== '/') {
      if (location.pathname === '/advantage') {
        this.signinUrl = '/signin?next=/desktop'
      } else {
        this.signinUrl = '/signin?next=' + location.pathname
      }
    }
    let that = this

    this.$nextTick(() => {
      ywk.addEvent(document, 'scroll', () => {
        if (document.body.clientWidth >= 720) {
          that.scroll = !window.isBudget
        } else {
          that.scroll = false
        }
      })
    })
    const timer = window.setInterval(() => {
      if (this.profile && this.profile.id) {
        wkxUnread.initUnreadSocket({usergroup_id: 'yunxun_999999999'})
        window.clearInterval(timer)
      }
    }, 500)
  },
  methods: {
    /** 获取牛人活动 */
    getGenius () {
      ywk.getJson(this.prePath + '/api/v2/activity/genius-active').then((res) => {
        if (res.error_code === 0) {
          this.genius = res.genius
        }
      })
    },
    login (key, path) {
      ywk.goLogin(key, path)
    },
    loginOut () {
      // 退出
      ywk.postJson('/api/sso/signout').then((res) => {
        if (res.error_code === 0) {
          this.showModal = false
          window.location.href = this.prePath
        } else {
          this.$alert('error', res.msg)
        }
      })
    },
    getNotifyCount () {
      ywk.getJson('/api/v2/notify', {t: 'ucount'}).then((res) => {
        if (res.error_code === 0) {
          this.count = res.count
        }
      })
    },
    addFavorite () {
      try {
        if (window.sidebar) {
          window.sidebar.addPanel(document.title, window.location, '')
        } else {
          window.external.addFavorite(window.location, document.title)
        }
      } catch (e) {
        this.$alert('error', '您所使用的浏览器无法完成此操作，请手动添加到收藏夹')
      }
    }
  },
  components: {
    modal
  }
}
</script>
<style lang="postcss" scoped>
.yunliao-container{
    width: 50px;
    height: 50px;
    min-height: auto;
    min-width: auto;
    border-radius: 2px;
    position: fixed;
    bottom: 153px;
    right: 0;
    padding: 0 16px;
    cursor: pointer;
    transition: 0.3s;
    background: #b5b5b5 url(../assets/images/wkx/icon-chat.png) no-repeat 16px center;
    overflow: hidden;
    z-index: 9;
    box-sizing: border-box;

    &:hover {
      background: #ff6710 url(../assets/images/wkx/icon-chat.png) no-repeat 85px center;
      width: 119px;

      >p {
        display: block;
      }

      #yunliao-report {
        left: 90px;
      }
    }
    > p{
      display: none;
      font-size: 14px;
      font-weight: lighter;
      color: #fff;
      letter-spacing: 1.15px;
      line-height: 50px;
    }
    #yunliao-report {
      background: #ff5050;
      padding: 0 6px;
      border-radius: 100%;
      color: #fff;
      text-align: center;
      position: absolute;
      left: 21px;
      top: 6px;
      transform: scale(0.66, 0.66);
    }
  }
@keyframes rolling {
  from {left: 0}
  to {left: -200%}
}

.global-header {
  width: 100%;
  background: #fff;
  height: 110px;
  &.shadow {
    box-shadow: 0 1px 4px 0 rgba(238,238,238,0.50);
    height: 105px;
  }
  &.basic {
    height: 40px;
  }

  .top-bar {
    background: #fafafa;
    width: 100%;
    height: 40px;
    &.fixed {
      position: fixed;
      top: 0;
      z-index: 3;
      & + .header-box {
        padding-top: 40px;
      }
    }
    & > div {
      width: 1200px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      & > p {
        float: left;
        font-size: 12px;
        color: #666;
        letter-spacing: 2.25px;
        padding-left: 21px;
        background: url('../assets/images/common/header-icon-app.png') no-repeat left;
        position: relative;
        &:hover {
          color: #ff6710;
          span {
            display: inline-block;
          }
        }
        span {
          display: none;
          position: absolute;
          left: 0;
          top: 50px;
          border: 1px solid #ebebeb;
          padding: 10px;
          background: #fff;
          z-index: 3;
          img {
            width: 150px;
            height: 150px;
            display: block;
          }
        }
      }
      .service {
        margin-left: 29px;
        padding-left: 16px;
        background: url('../assets/images/common/header-icon-service.png') no-repeat left;
        a {
          color: #666;
          &:hover {
            color: #ff6710;
          }
        }
      }
      & > div {
        float: right;
        & > div {
          float: left;
          font-size: 12px;
          color: #666;
          letter-spacing: 2.25px;
          margin-left: 20px;
        }
        & > ul {
          overflow: hidden;
          float: left;
          li {
            float: left;
            margin-left: 18px;
            font-size: 12px;
            color: #666;
            letter-spacing: 2.25px;
            &:first-child {
              margin-left: 0;
            }
            a {
              cursor: pointer;
              color: #666;
              &:hover {
                color: #ff6710;
              }
            }
          }
          .collect {
            padding-left: 16px;
            background: url('../assets/images/common/header-icon-collect.png') no-repeat left;
          }
          .myjobs {
            padding-left: 16px;
            background: url('../assets/images/common/header-icon-jobs.png') no-repeat left;
          }
          .notify {
            padding-left: 13px;
            background: url('../assets/images/common/header-icon-notify.png') no-repeat left;
            &.active {
              a {
                color: #ff6710;
                span {
                  em {
                    font-weight: 600;
                    font-style: normal;
                  }
                }
              }
              background: url('../assets/images/common/header-icon-notify-orange.png') no-repeat left;
            }
          }
        }
      }
      .user-avater {
        position: relative;
        & + a {
          cursor: pointer;
        }
        img {
          width: 20px;
          height: 20px;
          border-radius: 100%;
          position: relative;
          top: 5px;
        }
        span {
          display: inline-block;
          width: 100px;
          vertical-align: top;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
          color: #666;
        }
        &:hover > div {
          display: block;
        }
        & > div {
          display: none;
          position: absolute;
          right: 0;
          z-index: 3;
          top: 12px;
          ul {
            width: 120px;
            overflow: hidden;
            background: #fff;
            border: 1px solid #ebebeb;
            border-radius: 4px;
            padding: 19px 0 20px;
            margin-top: 15px;
            li {
              line-height: 17px;
              min-height: 17px;
              margin-top: 15px;
              position: relative;
              &:first-child {
                margin-top: 0;
              }
              a {
                font-size: 14px;
                color: #999;
                max-width: 78px;
                margin: 0 auto;
                letter-spacing: 2.09px;
                cursor: pointer;
                text-align: center;
                display: block;
                overflow: hidden;
                &:hover {
                  color: #ff6710;
                }
              }
            }
          }
        }
      }
      i {
        width: 1px;
        height: 14px;
        display: inline-block;
        float: left;
        background: #999;
        margin: 12px 20px;
      }
    }
    .exit {
      display: inline-block;
      width: 14px;
      height: 14px;
      position: relative;
      top: 2px;
      background: url('../assets/images/common/header-icon-exit.png') no-repeat center;
    }
  }

  .header-box {
    width: 1200px;
    height: 70px;
    line-height: 70px;
    margin: 0 auto;
  }

  .logo {
    width: 152px;
    height: 57px;
    background: url('../assets/images/common/logo.png') no-repeat center center;
    float: left;
    margin-top: 1px;
  }
  .nav-box {
    float: left;
    overflow: hidden;
    margin-left: 25px;
    li {
      float: left;
    }
    a {
      font-size: 14px;
      color: #333;
      letter-spacing: 1px;
      padding: 0 18px;
      cursor: pointer;
      display: block;
      position: relative;
      &.active {
        color: #ff6710;
      }
      &:hover {
        color: #ff6710;
      }
    }
    .line {
      a {
        display: inline-block;
      }
      &:before {
        content: '';
        display: inline-block;
        width: 1px;
        height: 21px;
        background: #eee;
        position: relative;
        top: 5px;
      }
    }
    .menu-ent {
      display:inline-block;
      width: 54px;
      height: 34px;
      margin-top: 18px;
    }
    .menu-resident {
      display:inline-block;
      width: 58px;
      height: 16px;
      margin-top: 27px;
    }
    .icon-menu-award {
      position: absolute;
      right: 15px;
      top: 13px;
      display: inline-block;
      width: 29px;
      height: 18px;
    }
    .new a:after {
      content: '';
      display: inline-block;
      width: 25px;
      height: 9px;
      position: absolute;
      right: 15px;
      top: -9px;
      background: url('../assets/images/common/header-icon-new.png') no-repeat center;
    }
  }
  .user-box {
    float: right;
    a {
      display: inline-block;
      vertical-align: middle;
    }
    .publish {
      width: 100px;
      line-height: 34px;
      height: 34px;
      background: #ff6710;
      border-radius: 4px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      margin-right: 26px;
    }
    .opt-btn {
      font-size: 16px;
      color: #333;
      letter-spacing: 3px;
      padding: 0 14px;
      &.login {
        margin-left: 23px;
      }
    }
    .login-out {
      width: 25px;
      height: 25px;
      margin-right: 25px;
      cursor: pointer;
      background: url('../assets/images/icons/login_out.png') no-repeat center center;
    }
    .search {
      width: 20px;
      height: 20px;
      background: url('../assets/images/icons/icon_search.png') no-repeat center center;
      margin-right: 28px;
    }
    .notify {
      width: 25px;
      height: 20px;
      background: url('../assets/images/icons/icon_notify.png') no-repeat center center;
      margin-right: 26px;

      blockquote {
        position: relative;
        width: 24px;
        height: 24px;
        color: #fff;
        background: red;
        border-radius: 50%;
        margin: 0;
        top: -15px;
        left: 5px;
        font-size: 10px;
        text-align: center;
        line-height: 24px;
      }
    }
  }
}
</style>
